import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt-BR",
    debug: false,
    interpolation: {
      escapeValue: true,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    lng: "pt-BR",
  });

export default i18n;
